import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAppSelector } from '../ReduxToolkit/Hooks';

/**
 * Route guard pour /admin.
 * Se base exclusivement sur les rôles émis par le backend dans le JWT (source de vérité).
 * Tout utilisateur non autorisé est immédiatement ramené vers / sans notification ni modal.
 */
const AdminRoute: React.FC = () => {
  const { isAuthenticated, currentUser } = useAppSelector((state) => state.auth);
  const token = localStorage.getItem('accessToken');

  const permissions = currentUser?.permissions || [];
  const hasAuthorizedPermission = permissions.some((p: string) => [
    'view_staff_users', 'view_individual_users', 'view_business_users',
    'create_staff_account', 'activate_account', 'assign_user_group', 'reset_user_password',
    'add_doc', 'edit_doc', 'delete_doc', 'view_stats', 'manage_group_perms',
    'view_logins', 'view_consultations', 'view_downloads', 'view_searches'
  ].includes(p));

  const role = currentUser?.role;
  const isAuthorized = Boolean(
    isAuthenticated &&
    token &&
    (
      role === 'ADMIN' ||
      role === 'STAFF' ||
      (typeof role === 'string' && (role.toUpperCase() === 'ADMIN' || role.toUpperCase() === 'STAFF')) ||
      (Array.isArray(role) && role.some((r: string) => typeof r === 'string' && (r.toUpperCase() === 'ADMIN' || r.toUpperCase() === 'STAFF'))) ||
      hasAuthorizedPermission
    )
  );

  if (!isAuthorized) {
    return <Navigate to="/dashboard" replace />;
  }

  return <Outlet />;
};

export default AdminRoute;
